import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import { useEffect } from 'react';

import useDialog from 'hooks/useDialog';

import { removeHashFromUrl } from 'lib/request';

const WishlistDialog = dynamic(() => import('.'), {
  ssr: false,
});

const WISHLIST_HASH = '#wishlist';

const WishlistModalOnUrlHash = () => {
  const router = useRouter();
  const { showDialog } = useDialog();

  useEffect(() => {
    if (window.location.hash === WISHLIST_HASH) {
      showDialog(WishlistDialog);
      removeHashFromUrl(router);
    }
  }, []);

  return null;
};

export default WishlistModalOnUrlHash;
